export enum StepType {
  Buyer = 'buyer',
  CoBuyer = 'coBuyer',
  General = 'General'
}
